export const AVATAR_SLOTS = {
  eyes: "eyes",
  mouth: "mouth",
  blush: "blush",
  hair: "hair",
  shirt: "shirt",
  shirt2: "shirt2",
  shirt3: "shirt3",
  pant: "pant",
  pant2: "pant2",
  skirt: "skirt",
  headWear: "head_wear",

  holdableRight: "holdable_right",
  holdableLeft: "holdable_left",
  food: "foodSlot",
  chatBubble: "chat1",
  button: "button",
  button2: "button2",
  buttonSplash: "button splash2",

  tears: "tears",
  tears2: "tears2",
  embarrassed: "embarrassed",
  exclamation: "exmalation",
  explosion: "explotion",
  heart: "heart",
  talkIcon: "talkIcon",
  talkIcon2: "talkIcon2",
  talkIcon3: "talkIcon3",
  talkIcon4: "talkIcon4",
} as const;
